<template>
  <router-view />
</template>

<script>
  import styles from './sass/styles.css'
  export default {
    name: 'App',
  }
</script>

<style>

</style>
